/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterListMemberPreviewDtoSchema = z.object({
  avatarUrl: z.string().nullish(),
  displayName: z.string().nullish(),
  role: z.string().nullish(),
});
